import { CountFilterType } from 'modules/queryBuilder/types';

export const COUNT_FILTER_LABEL = {
  [CountFilterType.ANY]: 'storybook.countFilter.countFilterType.any',
  [CountFilterType.EXACTLY]: 'storybook.countFilter.countFilterType.exactly',
  [CountFilterType.BETWEEN]: 'storybook.countFilter.countFilterType.between',
};

export const MINIMUM = 1;
export const MAXIMUM = 999;
export const COUNT_LIMIT = 1000;
